import { createApp } from 'vue'
import App from '@/page/vue/2024/event/signup.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import { Swipe, SwipeItem } from 'vant'
import 'vant/lib/index.css'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC.AI 2024 官宣！引领数字安全风向，拓局AI全新战场',
  desc: '7月31日-8月1日北京国家会议中心，开启“聚变元年”',
  imgUrl: 'https://p1.ssl.qhimg.com/t11b673bcd66fc5580119842a03.png',
  link: window.location.href
})


const app = createApp(App)
app.use(Swipe)
app.use(SwipeItem)
app.mount('#app')
